module.exports = ".card-blue {\n  margin: 0 4rem;\n  font-weight: 800;\n  background: #335281;\n  color: white;\n  font-size: 23px;\n  line-height: 26px;\n  padding: 12px; }\n\n#triangle-down {\n  width: 0;\n  height: 0;\n  border-left: 0px solid transparent;\n  border-right: 41px solid transparent;\n  border-top: 33px solid #335281;\n  margin-left: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ringraziamento/ringraziamento.component.scss
// module id = ./src/app/ringraziamento/ringraziamento.component.scss
// module chunks = main